import HistoryAgentStore from "./HistoryAgentStore";

class AgentsWidgetHistoryStore extends HistoryAgentStore {
}

export default AgentsWidgetHistoryStore; 